import { Container } from 'reactstrap'
import { H5, Image } from '../../../../AbstractElements'
import { WeAreComingSoon } from '../../../../Utils/Constants'
import CountdownData from '../Common/CountdownData'
import { dynamicImage } from '../../../../Utils'

const ComingWithBgVideoContainer = () => {
  return (
    <Container fluid className="p-0">
      <div className="comingsoon auth-bg-video">
        <video className="bgvideo-comingsoon" id="bgvid" poster={dynamicImage("other-images/coming-soon-bg.jpg")} playsInline autoPlay muted loop>
         <source src={process.env.PUBLIC_URL + "/assets/video/auth-bg.mp4"} type="video/mp4" />
        </video>
        <div className="comingsoon-inner text-center">
          <Image className="for-light" src={dynamicImage("other-images/logo-login.png")} alt="coming soon" />
          <Image className="for-dark mx-auto" src={dynamicImage("other-images/logo-light.png")} alt="coming soon" />
          <H5>{WeAreComingSoon}</H5>
          <div className="countdown" id="clockdiv">
            <CountdownData />
          </div>
        </div>
      </div>
    </Container>
  )
}

export default ComingWithBgVideoContainer